'use strict';

var EditNat = require('actionGroups/outboundNat/Nat');

module.exports = {
  Model: EditNat,
};
